import {shape, string, boolean} from 'prop-types';

export default shape({
  isLoaded: boolean,
  isLoading: boolean,
  settings: shape({
    systemMeasure: string
  })
});
